import React from 'react'
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Gratis from './../../Gratis/Gratis';
import Rodape from '../../Rodape/Rodape';
import Box from '@mui/material/Box';

function FreteGratis() {
  return (    
    <div>      
      <NavBarTop />   
      <Box sx={{ marginBottom: 3 }} >
        <Gratis />
      </Box>
      <Rodape />
    </div>
  )
}
export default FreteGratis